import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'gridActionToString',
})
export class GridActionToStringPipe implements PipeTransform {
  transform(value: any): string {
    return value.toString();
  }
}
